import { render, staticRenderFns } from "./PolarCoach.vue?vue&type=template&id=7de7106c&"
import script from "./PolarCoach.vue?vue&type=script&lang=js&"
export * from "./PolarCoach.vue?vue&type=script&lang=js&"
import style0 from "./PolarCoach.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports